import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { useDebounce } from '../hooks';
import { ColhedorService } from '../services/api/ColhedorService';


type TAutoCompleteOption = {
  guuidcolhedor: string;
  label: string;
} 

interface IAutoCompleteProps {
  isExternalLoading?: boolean;
  idcolhedor?: (novoTextoselect: string | undefined) => void;
  nome?: (novoTextoselect: string | undefined) => void;
}

export const AutoCompleteColhedor1: React.FC<IAutoCompleteProps> = ({ isExternalLoading = false, idcolhedor, nome}) => {
  const { debounce } = useDebounce();

  const [selectedId, setSelectedId] = useState<string | undefined>('');

  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState('');

  useEffect(() => {
    setIsLoading(true);

    debounce(() => {
      ColhedorService.getAllList(busca, selectedId)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            // alert(result.message);
          } else {
            setOpcoes(result.data.map(colhedor => ({ guuidcolhedor: colhedor.guuidcolhedor, label: colhedor.nome })));
          }
        });
    });

  }, [busca, selectedId]);

  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;

    const selectedOption = opcoes.find(opcao => opcao.guuidcolhedor === selectedId);
    if (!selectedOption) return null;

    return selectedOption; 
  }, [selectedId, opcoes]);

  return (
    <Autocomplete
      openText='Abrir'
      closeText='Fechar'
      noOptionsText='Sem opções'
      loadingText='Carregando...'

      disablePortal

      options={opcoes}
      loading={isLoading}
      disabled={isExternalLoading}
      value={autoCompleteSelectedOption}
      onInputChange={(_, newValue) => setBusca(newValue)}
      onChange={(_, newValue) => { setSelectedId(newValue?.guuidcolhedor); idcolhedor?.(newValue?.guuidcolhedor); nome?.(newValue?.label); setBusca(''); }}
      popupIcon={(isLoading) ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          size='small'
          label="Colhedor"
        />
      )}
    />
  );
};